<main class="em-l-container main-content">
  <div *ngIf="isLoading">
    <app-loader></app-loader>
  </div>

  <div *ngIf="!isLoading">
    <!-- Breadcrumbs -->
    <supplier-breadcrumbs [items]="breadcrumbItems"></supplier-breadcrumbs>

    <!-- Create form -->
    <fieldset class="em-c-fieldset">
      <div class="em-l-grid em-l-grid--2up">
        <!-- Supplier Identity -->
        <div class="em-l-grid__item">
          <div class="em-c-field">
            <label for="" class="em-c-field__label">Supplier Identity</label>
            <div class="em-c-field__body">
              <input
                [(ngModel)]="supplierIdentity"
                class="em-c-input em-js-input"
                value="{{ supplierIdentity }}"
                disabled
              />
              <svg class="em-c-icon em-c-icon--medium em-c-field__icon">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#lock"
                ></use>
              </svg>
            </div>
          </div>
        </div>
        <!-- Supplier Description -->
        <div class="em-l-grid__item">
          <div class="em-c-field">
            <label for="" class="em-c-field__label">Supplier Description</label>
            <div class="em-c-field__body">
              <input
                [(ngModel)]="supplierName"
                class="em-c-input em-js-input"
                value="{{ supplierName }}"
                disabled
              />
              <svg class="em-c-icon em-c-icon--medium em-c-field__icon">
                <use
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xlink:href="assets/unity-1.6.0/images/24/em-icons.svg#lock"
                ></use>
              </svg>
            </div>
          </div>
        </div>
        <!-- Plant -->
        <div class="em-l-grid__item">
          <plant-input
            [(selectedValue)]="plant"
            (selectedValueChange)="validationError.plant = ''"
            [error]="validationError.plant"
          ></plant-input>
        </div>
        <!-- Vendor -->
        <div class="em-l-grid__item">
          <vendor-input
            [(selectedValue)]="vendor"
            (selectedValueChange)="validationError.vendor = ''"
            [error]="validationError.vendor"
          ></vendor-input>
        </div>
      </div>
    </fieldset>

    <h4>Exceptions</h4>
    <exception-table
      [isViewOnly]="false"
      (saveException)="handleSaveException($event)"
      (validateSupplierProfile)="checkValidation($event)"
    >
    </exception-table>
  </div>
</main>
